import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";
import * as actionTypes from "./actionTypes";
import { notify } from "../../helpers/utility";

//3.Get Conf Room Details
export const getConfDetailsStart = () => {
  return {
    type: actionTypes.GET_CONF_DETAIL_START,
  };
};

export const getConfDetailsFail = (error) => {
  return {
    type: actionTypes.GET_CONF_DETAIL_FAIL,
    error: error,
  };
};

export const getConfDetailsSuccess = (agentId, confDetails) => {
  return {
    type: actionTypes.GET_CONF_DETAIL_SUCCESS,
    confDetails: confDetails,
  };
};

export const getConfDetails = (agentId) => {
  return (dispatch) => {
    dispatch(getConfDetailsStart());
    ctiRequest["CTI_CHECK_CONF_STAT"].agent_id = agentId;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_CHECK_CONF_STAT"].ip = window.clientIP;
    axios
      .post("/", ctiRequest["CTI_CHECK_CONF_STAT"])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          dispatch(
            getConfDetailsSuccess(agentId, result.data.response.conf_details)
          );
        } else {
          dispatch(getConfDetailsFail(result.data.response.reason));
          console.log(result.data.response.reason);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(getConfDetailsFail(err));
      });
  };
};

//1. Leave Conf Room
export const leaveConfStart = () => {
  return {
    type: actionTypes.LEAVE_CONF_START,
  };
};

export const leaveConfFail = (error) => {
  return {
    type: actionTypes.LEAVE_CONF_FAIL,
    error: error,
  };
};

export const leaveConfSuccess = (agentId) => {
  return {
    type: actionTypes.LEAVE_CONF_SUCCESS,
  };
};

export const leaveConf = (agentId) => {
  return (dispatch) => {
    dispatch(leaveConfStart());
    ctiRequest["CTI_CONF_LOGIN"].agent_id = agentId;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_CONF_LOGIN"].ip = window.clientIP;
    axios
      .post("/", ctiRequest["CTI_CONF_LOGIN"])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          dispatch(leaveConfSuccess(agentId));
        } else {
          notify(
            "Conference Error: " + result.data.response.reason,
            "agent-conference"
          );
          dispatch(leaveConfFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Conference Error", "agent-conference");
        dispatch(leaveConfFail(err));
      });
  };
};

//2. Join Conf Room
export const joinConfStart = (actionType) => {
  return {
    type: actionTypes.JOIN_CONF_START,
    actionType: actionType,
  };
};

export const joinConfFail = (error) => {
  return {
    type: actionTypes.JOIN_CONF_FAIL,
    error: error,
  };
};

export const joinConfSuccess = (agentId) => {
  return {
    type: actionTypes.JOIN_CONF_SUCCESS,
  };
};

export const joinConf = (agentId, cond, confRoom, phone, isParkedCall, parkId) => {
  console.log(isParkedCall)
  return (dispatch) => {
    let actionType =
      cond === "join_agent_cust_conf"
        ? "joinConf"
        : cond === "transfer"
        ? "joinCustomer"
        : "joinAgent";
    dispatch(joinConfStart(actionType));
    let api = "CTI_JOIN_CONFERENCE";
    if (cond === "transfer") {
      api = "CTI_CONFERENCE_TRANSFER";
      ctiRequest["CTI_CONFERENCE_TRANSFER"].conf_room = confRoom;
      ctiRequest["CTI_CONFERENCE_TRANSFER"].phone_no = phone;
      ctiRequest["CTI_CONFERENCE_TRANSFER"].is_parked_call = isParkedCall ;
      ctiRequest["CTI_CONFERENCE_TRANSFER"].call_park_id = parkId;
    } else {
      ctiRequest["CTI_JOIN_CONFERENCE"].cond = cond;
      ctiRequest["CTI_JOIN_CONFERENCE"].conf_room = confRoom;
      ctiRequest["CTI_JOIN_CONFERENCE"].exten = phone;
    }
    ctiRequest[api].agent_id = agentId;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest[api].ip = window.clientIP;

    axios
      .post("/", ctiRequest[api])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          dispatch(joinConfSuccess(agentId));
          //getConfDetails(agentId);
        } else {
          notify(
            "Join Conference Error: " + result.data.response.reason,
            "agent-conference"
          );
          dispatch(joinConfFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Join Conference Error", "agent-conference");
        dispatch(joinConfFail(err));
      });
  };
};

//4. Conf Disconnect
export const confDisconnectStart = () => {
  return {
    type: actionTypes.CONF_DISCONNECT_START,
  };
};

export const confDisconnectFail = (error) => {
  return {
    type: actionTypes.CONF_DISCONNECT_FAIL,
    error: error,
  };
};

export const confDisconnectSuccess = (agentId, channel, endTime) => {
  return {
    type: actionTypes.CONF_DISCONNECT_SUCCESS,
    channel,
    endTime,
  };
};

export const confDisconnect = (agentId, channel) => {
  return (dispatch) => {
    dispatch(confDisconnectStart());
    ctiRequest["CTI_CONF_DISCONNECT"].agent_id = agentId;
    ctiRequest["CTI_CONF_DISCONNECT"].channel = channel;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_CONF_DISCONNECT"].ip = window.clientIP;
    const disconnectTime = Math.floor(Date.now() / 1000);

    axios
      .post("/", ctiRequest["CTI_CONF_DISCONNECT"])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          dispatch(confDisconnectSuccess(agentId, channel, disconnectTime));
          dispatch(getConfDetails(agentId));
        } else {
          notify(
            "Conference Disconnect Error: " + result.data.response.reason,
            "agent-conference"
          );
          dispatch(confDisconnectFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Conference Disconnect Error", "agent-conference");
        dispatch(confDisconnectFail(err));
      });
  };
};

//5. Conf Back to agent
export const backToAgentStart = () => {
  return {
    type: actionTypes.BACK_TO_AGENT_START,
  };
};

export const backToAgentFail = (error) => {
  return {
    type: actionTypes.BACK_TO_AGENT_FAIL,
    error: error,
  };
};

export const backToAgentSuccess = (agentId) => {
  return {
    type: actionTypes.BACK_TO_AGENT_SUCCESS,
  };
};

export const backToAgent = (agentId, channel) => {
  return (dispatch) => {
    dispatch(backToAgentStart());
    ctiRequest["CTI_CONF_BACK_TO_AGENT"].agent_id = agentId;
    ctiRequest["CTI_CONF_BACK_TO_AGENT"].channel = channel;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_CONF_BACK_TO_AGENT"].ip = window.clientIP;
    axios
      .post("/", ctiRequest["CTI_CONF_BACK_TO_AGENT"])
      .then((result) => {
        
        if (result.data.response.status === "SUCCESS") {
          dispatch(backToAgentSuccess(agentId));
        } else {
          notify(
            "Conference Leave Error: " + result.data.response.reason,
            "agent-conference"
          );
          dispatch(backToAgentFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Conference Leave Error", "agent-conference");
        dispatch(backToAgentFail(err));
      });
  };
};

//6. Conf Mute
export const confMuteStart = (actionType) => {
  return {
    type: actionTypes.CONF_MUTE_START,
    actionType: actionType,
  };
};

export const confMuteFail = (error) => {
  return {
    type: actionTypes.CONF_MUTE_FAIL,
    error: error,
  };
};

export const confMuteSuccess = (agentId) => {
  return {
    type: actionTypes.CONF_MUTE_SUCCESS,
  };
};

export const confMute = (
  agentId,
  channel,
  confno,
  mute,
  confFd,
  ztcChan,
  ztcConfno,
  actionType
) => {
  return (dispatch) => {
    dispatch(confMuteStart(actionType));
    ctiRequest["CTI_CONF_MUTE"].agent_id = agentId;
    ctiRequest["CTI_CONF_MUTE"].channel = channel;
    ctiRequest["CTI_CONF_MUTE"].confno = confno;
    ctiRequest["CTI_CONF_MUTE"].mute = mute;
    ctiRequest["CTI_CONF_MUTE"].conf_fd = confFd;
    ctiRequest["CTI_CONF_MUTE"].ztc_chan = ztcChan;
    ctiRequest["CTI_CONF_MUTE"].ztc_confno = ztcConfno;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_CONF_MUTE"].ip = window.clientIP;
    axios
      .post("/", ctiRequest["CTI_CONF_MUTE"])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          dispatch(confMuteSuccess(agentId));
        } else {
          notify(
            "Conference Mute Error: " + result.data.response.reason,
            "agent-conference"
          );
          dispatch(confMuteFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Conference Mute Error", "agent-conference");
        dispatch(confMuteFail(err));
      });
  };
};

//7. Conf Dial
export const confDialStart = () => {
  return {
    type: actionTypes.CONF_DIAL_START,
  };
};

export const confDialFail = (error) => {
  return {
    type: actionTypes.CONF_DIAL_FAIL,
    error: error,
  };
};

export const confDialSuccess = (agentId) => {
  return {
    type: actionTypes.CONF_DIAL_SUCCESS,
  };
};

export const confDial = (
  agentId,
  phoneNumber,
  dialType,
  vdnSelect,
  agentState,
  confRoom
) => {
  return (dispatch) => {
    dispatch(confDialStart());
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    let action = 'CTI_CONFERENCE_DIAL';
    if (agentState === "CONF") {
      action = 'CTI_CONFERENCE_DIRECT_DIAL';
      ctiRequest["CTI_CONFERENCE_DIRECT_DIAL"].agent_id = agentId;
      ctiRequest["CTI_CONFERENCE_DIRECT_DIAL"].phone_no = phoneNumber;
      ctiRequest["CTI_CONFERENCE_DIRECT_DIAL"].dialType = dialType;
      ctiRequest["CTI_CONFERENCE_DIRECT_DIAL"].vdn_select = vdnSelect;
      ctiRequest["CTI_CONFERENCE_DIRECT_DIAL"].conf_room = confRoom;
      ctiRequest["CTI_CONFERENCE_DIRECT_DIAL"].ip = window.clientIP;
    } else {
      ctiRequest["CTI_CONFERENCE_DIAL"].agent_id = agentId;
      ctiRequest["CTI_CONFERENCE_DIAL"].phone_no = phoneNumber;
      ctiRequest["CTI_CONFERENCE_DIAL"].dialType = dialType;
      ctiRequest["CTI_CONFERENCE_DIAL"].vdn_select = vdnSelect;
      ctiRequest["CTI_CONFERENCE_DIAL"].ip = window.clientIP;
    }

    axios
      .post("/", ctiRequest[action])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          notify("Conference Dial Success", "agent-conference", "success");
          dispatch(confDialSuccess(agentId));
          getConfDetails(agentId);
        } else {
          notify(
            "Conference Dial Error: " + result.data.response.reason,
            "agent-conference"
          );
          dispatch(confDialFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Conference Dial Error", "agent-conference");
        dispatch(confDialFail(err));
      });
  };
};

//8. Send DTMF
export const sendDtmfStart = () => {
  return {
    type: actionTypes.SEND_DTMF_START,
  };
};

export const sendDtmfFail = (error) => {
  return {
    type: actionTypes.SEND_DTMF_FAIL,
    error: error,
  };
};

export const sendDtmfSuccess = (agentId) => {
  return {
    type: actionTypes.SEND_DTMF_SUCCESS,
  };
};

export const sendDtmf = (agentId, digit, channle, confFlag) => {
  return (dispatch) => {
    dispatch(sendDtmfStart());
    ctiRequest["CTI_SEND_DTMF"].agent_id = agentId;
    ctiRequest["CTI_SEND_DTMF"].digit = digit;
    ctiRequest["CTI_SEND_DTMF"].channel = channle;
    ctiRequest["CTI_SEND_DTMF"].conf_flag = confFlag;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_SEND_DTMF"].ip = window.clientIP;
    axios
      .post("/", ctiRequest["CTI_SEND_DTMF"])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          dispatch(sendDtmfSuccess(agentId));
        } else {
          notify(
            "DTMF Error: " + result.data.response.reason,
            "agent-conference"
          );
          dispatch(sendDtmfFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify("DTMF Error", "agent-conference");
        dispatch(sendDtmfFail(err));
      });
  };
};

//9. Get conf Online Agent Details
export const getOnlineAgentStart = () =>{
  return {
    type: actionTypes.ONLINE_AGENT_START
  }
}

export const getOnlineAgentFail = () =>{
  return{
    type : actionTypes.ONLINE_AGENT_FAIL
  }
}
export const getOnlineAgentSuccess = (agentId, agentDetails) =>{
  return {
    type: actionTypes.ONLINE_AGENT_SUCCESS,
    agentDetails: agentDetails,
  }
}
export const getOnlineAgent = (agentId, campName) =>{
  return (dispatch) =>{
    dispatch(getOnlineAgentStart());
    ctiRequest["CTI_ONLINE_AGENTS_NAME"].agent_id = agentId;
    ctiRequest["CTI_ONLINE_AGENTS_NAME"].campaign_name = campName;
    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_ONLINE_AGENTS_NAME"].ip = window.clientIP;
    axios
    .post("/", ctiRequest["CTI_ONLINE_AGENTS_NAME"])
    .then((result) =>{
      if(result.data.response.status === "SUCCESS"){
       dispatch(
        getOnlineAgentSuccess(agentId, result.data.response.online_agents)
       )
      }
      else{
         dispatch(getOnlineAgentFail(result.data.response.reason))
      }
    })
    .catch((err) =>{
      console.log(err)
      dispatch(getOnlineAgentFail(err))
    })
  }
}

